import React from 'react';
import { Nav, Button } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Obter informações do usuário
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  // Função para fazer logout
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };
  
  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h3>Dark Telegram</h3>
      </div>
      
      {user.name && (
        <div className="user-info">
          <p>Olá, {user.name}</p>
        </div>
      )}
      
      <Nav className="flex-column">
        <Nav.Link 
          as={Link} 
          to="/dashboard" 
          className={location.pathname === '/dashboard' ? 'active' : ''}
        >
          Dashboard
        </Nav.Link>
        <Nav.Link 
          as={Link} 
          to="/domains" 
          className={location.pathname === '/domains' ? 'active' : ''}
        >
          Domínios
        </Nav.Link>
        <Nav.Link 
          as={Link} 
          to="/pixels" 
          className={location.pathname === '/pixels' ? 'active' : ''}
        >
          Pixels
        </Nav.Link>
        <Nav.Link 
          as={Link} 
          to="/datasets" 
          className={location.pathname === '/datasets' ? 'active' : ''}
        >
          DataSets
        </Nav.Link>
      </Nav>
      
      <div className="sidebar-footer">
        <Button 
          variant="outline-light" 
          onClick={handleLogout}
          className="logout-button"
        >
          Sair
        </Button>
      </div>
    </div>
  );
};

export default Sidebar; 